


import { Link } from "react-router-dom";
import { IsAuthorizeUser } from "../../../lib/authenticationLibrary";
import { hasPermission } from "../../../utils/authorizeNavigation/authorizeNavigation";

const SideBarSubMenuItem = (props) => {
    return (
        <div className="dropdown">
            <ul className="sub-menu">
                {props.childItems.map((childItem, childIndex) => (
                    <>
                        {
                            hasPermission(childItem.securityKey)
                                ?
                                <li
                                    key={childIndex}
                                    className={`${props.clickedValueSubMenu === childItem ? "child-active" : ""}`}
                                    onClick={(e) => props.handleSubItemClick(e, childItem)}>
                                    <Link to={childItem.to}>{childItem.name}</Link>
                                </li>
                                : null
                        }
                    </>
                ))}
            </ul>
        </div>
        // <div className="dropdown">
        //     <ul className="sub-menu">
        //         {props.childItems.map((childItem, childIndex) => (
        //             <>
        //                 {IsAuthorizeUser(childItem.Role) !== undefined ?
        //                     <li
        //                         key={childIndex}
        //                         className={`${props.clickedValueSubMenu === childItem ? "child-active" : ""}`}
        //                         onClick={(e) => props.handleSubItemClick(e, childItem)}>
        //                         <Link to={childItem.to}>{childItem.name}</Link>
        //                     </li> :
        //                     null}
        //             </>
        //         ))}
        //     </ul>
        // </div>
    )
}
export default SideBarSubMenuItem;
